import { imgUrl } from "../../lib/api";

export const Logo = ({ settings, size = "md" }) => {
  if (settings?.logo) {
    return (
      <img
        src={imgUrl(settings.logo)}
        alt={settings.store_name || "EMAIA PERFUMES"}
        className={size === "lg" ? "h-24 w-auto object-contain md:h-28" : "h-10 w-auto object-contain md:h-12"}
        data-testid="brand-logo-image"
      />
    );
  }
  const big = size === "lg";
  return (
    <span className="inline-flex flex-col items-center leading-none" data-testid="brand-logo-text">
      <span className={`gold-text font-serif font-semibold ${big ? "text-5xl tracking-[0.35em] md:text-6xl" : "text-2xl tracking-[0.3em] md:text-[28px]"}`}>
        EMAIA
      </span>
      <span className={`mt-1 text-[#F3E5AB]/80 ${big ? "text-xs tracking-[0.7em]" : "text-[9px] tracking-[0.6em]"}`}>PERFUMES</span>
    </span>
  );
};
